import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Cosa devo portare alla prima visita?",
    a: "Documento d'identità, tessera sanitaria, referti di esami recenti (in particolare emocromo, sideremia, ferritina, funzionalità epatica e renale) ed eventuale lettera del medico curante.",
  },
  {
    q: "In quali sedi ricevo?",
    a: "Presso la Fondazione IRCCS Policlinico San Matteo di Pavia (lun–gio) e presso lo Studio Viqueria di Voghera (ven–sab), sempre su appuntamento.",
  },
  {
    q: "Quanto dura una visita ematologica?",
    a: "Una prima visita dura circa 45 minuti: c'è tempo per l'anamnesi, la valutazione clinica e la lettura degli esami. I controlli successivi durano in media 20–30 minuti.",
  },
  {
    q: "Posso richiedere un secondo parere (second opinion)?",
    a: "Sì. Molti pazienti mi contattano per un secondo parere su diagnosi ematologiche complesse: portare tutta la documentazione disponibile (esami, biopsie, referti radiologici) facilita la consulenza.",
  },
  {
    q: "Come funziona la prenotazione online?",
    a: "Attraverso il modulo di questo sito indichi sede, data e orario desiderati. Riceverai conferma via email entro 24 ore lavorative dalla segreteria.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="py-24 md:py-32 bg-[#F9F8F6]">
      <div className="max-w-[1320px] mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <p className="eyebrow">05 — Domande frequenti</p>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight mt-6 text-[#1A1D1A]">
            Prima della <span className="italic text-[#8A6D56]">visita</span>.
          </h2>
          <p className="text-[#5C635E] mt-6">
            Le risposte alle domande che ricevo più spesso dai pazienti.
          </p>
        </div>

        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((item, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-[#E5E1D8]"
              >
                <AccordionTrigger className="text-left font-serif-display text-xl md:text-2xl text-[#1A1D1A] hover:no-underline py-6">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#5C635E] text-[15px] leading-relaxed pb-6 pr-8">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
